export const livewireModal = () => {
    const templateElement = document.querySelector('#livewire-modal');

    if (!templateElement) {
        return;
    }

    const bootstrapComponent = window.bootstrap.Modal.getOrCreateInstance(templateElement);

    window.Livewire.on('show-modal', () => {
        bootstrapComponent.show();
    });

    window.Livewire.on('hide-modal', () => {
        bootstrapComponent.hide();
    });
};
